module.exports = __webpack_public_path__ + "img/list_10_zh.d764b769.png";